<template>
<div>
    <v-layout>
        <v-flex xs12 sm12 md12 lg3>
            <h2>{{getString('Opzioni di sviluppo')}}</h2>
            <v-switch color='red lighten-3' :label="getString('Abilita modalità debug (Anche le chiamate success verranno memorizzate)')" v-model="debugState"></v-switch>
            <v-switch color='red lighten-3' :label="getString('Abilita modalità debug API (Le Api conterranno nella risposta l\'eventuale eccezione)')" v-model="debugStateApi"></v-switch>
            <span>{{getString('Abilita il bugtrack anche per le operazion normali, abilità la visibilità eccezioni nei json')}}</span>
            <h3>{{getString('Ottimizzazione memoria')}}</h3>
            <v-btn class="q-orange-bk q-text-whitesmoke" @click="removeZombie">{{getString('Rimozione fatture zombie')}}</v-btn>
            <v-progress-circular color="red lighten-3" indeterminate v-show="deleteLoading"></v-progress-circular>
        </v-flex>
        <v-flex xs12 sm12 md6 lg9>
            <v-card>
                <v-toolbar>
                    <v-toolbar-title>
                        Diagnostic
                    </v-toolbar-title>
                    <v-toolbar-items>
                        <v-btn flat @click="getTracks">
                            <v-icon>refresh</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-layout style="margin-top:25px">
                            <v-flex xs5>
                                <v-menu ref="dp1" :close-on-content-click="false" v-model="dp1" :nudge-right="40" :return-value.sync="dateStart" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                    <v-text-field slot="activator" v-model="dateStart" :label="getString('Da')" prepend-icon="event" readonly color="red lighten-2"></v-text-field>
                                    <v-date-picker :locale="locale" :title-date-format="formatTitle" show-current color="red lighten-2" v-model="dateStart" @input="$refs.dp1.save(dateStart)"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-spacer></v-spacer>
                            <v-flex xs5>
                                <v-text-field v-model="requestBugItems" :rules="numRule" :label="getString('Limite')" />
                            </v-flex>
                        </v-layout>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text id="com-table">
                    <v-text-field type="text" v-model="search" :label="getString('Filtra')" solo color="red lighten-3" />
                    <v-data-table :headers="Headers" :items="bugsItems" item-key="idLog" :search="search" :rows-per-page-items="[100,50,10,{text:getString('Tutto'),value:-1}]" :rows-per-page-text="getString('Log per pagina')" :no-data-text="getString('Dati non disponibili')" :loading="loading" class="elevation-0">
                        <template slot="items" slot-scope="props">
                            <tr @click="props.expanded = !props.expanded" style="max-height:100px;overflow:hidden;cursor:pointer">
                                <td class="text-xs-left">{{props.item.idLog}}</td>
                                <td class="text-xs-left">{{props.item.user > 0 ? props.item.user : getString('Anonimo')}}</td>
                                <td class="text-xs-left">{{props.item.userEmail !== '' ? props.item.userEmail : getString('nd')}}</td>
                                <td class="text-xs-left">{{props.item.action}}</td>
                                <td class="text-xs-left">{{props.item.date.split('T')[0]}} {{props.item.date.split('T')[1]}}</td>
                                <td class="text-xs-left">{{props.item.isType}}</td>
                                <td class="text-xs-left">
                                    <v-icon>{{props.item.output !== null ? (props.item.output.length > 1000 ? 'warning' : 'mood') : 'mood'}}</v-icon>
                                </td>
                            </tr>
                        </template>
                        <template slot="expand" slot-scope="props">
                            <v-card flat>
                                <v-card-title>
                                    <h2 class="q-orange">{{props.item.idLog}} - {{props.item.action}} - {{props.item.url}} - {{props.item.user}} - {{props.item.userEmail}}</h2>
                                </v-card-title>
                                <v-card-text>
                                    <h2>input</h2>
                                    {{props.item.input}}
                                </v-card-text>
                                <v-card-text>
                                    <h2>output</h2>
                                    {{props.item.output}}
                                </v-card-text>
                                <v-card-text>
                                    <h3>App</h3>
                                    {{props.item.appName}}
                                </v-card-text>
                                <v-card-text>
                                    <h3>Device</h3>
                                    {{props.item.deviceModel}}
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog v-model="sekKeyDialog" persistent max-width="290">
        <v-card>
            <v-card-title class="headline">{{getString('Inserisci chiave di sicurezza')}}</v-card-title>
            <v-card-text>
                {{getString('Per modifiche di alto borgo devi inserire la chiave di sicurezza?')}}
            </v-card-text>
            <v-card-text>
                <v-text-field type="password" v-model="skey" style="max-width:500px" solo :label="getString('s. key')"></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click.native="reset">{{getString('Torna alla pagina')}}</v-btn>
                <v-btn color="green darken-1" flat @click.native="setDebugState">{{getString('Ok')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import Utils from '../../utils.js'
import ajax from '../../ajax.js'
var ut = new Utils()
export default {
  name: 'Diagnostics',
  mounted: function() {
    
    this.getDebugState()
  },
  computed: {
    locale: function() {
      return this.$store.state.currentTranslator.locale
    },
    Headers: function() {
      let result = []
      let self = this
      if (this.bugsItems.length > 0) {
        let temp = [
          self.getString('IdLog:idLog'),
          self.getString('IdUtente:user'),
          self.getString('Email:userEmail'),
          self.getString('Azione:action'),
          self.getString('Data:date'),
          self.getString('Tipo:isType'),
          self.getString('BigRender')
        ]
        temp.forEach(element => {
          result.push({
            text: self.getString(element.split(':')[0]),
            align: 'left',
            sortable: true,
            value: element.split(':')[1]
          })
        })
        return result
      }
      return []
    },
    notEmpty: function() {
      return [v => !!v || this.getString('Campo richiesto')]
    },
    emailRule: function() {
      return [
        v => !!v || this.getString('Campo richiesto'),
        v => ut.ValidateEmail(v) || this.getString('Email non valida')
      ]
    },
    numRule: function() {
      return [
        v => !!v || this.getString('Campo richiesto'),
        v =>
          ut.ValidateNumber(v) ||
          this.getString('Numero non valido, torniamo a scuola per cortesia?')
      ]
    },
    debugState: {
      get: function() {
        return this.dState
      },
      set: function(value) {
        this.dState = value
        if (!this.switchInit) {
          this.debugType = 0
          this.enabled = this.dState
          this.setDebugState()
          //this.sekKeyDialog = true
        }
      }
    },
    debugStateApi: {
      get: function() {
        return this.dStateApi
      },
      set: function(value) {
        this.dStateApi = value
        if (!this.switchInitApi) {
          this.debugType = 1
          this.enabled = this.dStateApi
          this.setDebugState()
          //this.sekKeyDialog = true
        }
      }
    }
  },
  data: () => {
    return {
      deleteLoading: false,
      switchInit: true,
      switchInitApi: true,
      dState: false,
      dStateApi: false,
      h: null,
      skey: null,
      sekKeyDialog: false,
      notState: false,
      bugsItems: [],
      requestBugItems: 100,
      dp1: false,
      loading: false,
      dateStart:
        new Date().getFullYear() +
        '-' +
        ut.NumberWith0(new Date().getMonth()) +
        '-' +
        ut.NumberWith0(1),
      search: '',
      debugType: -1,
      enabled: -1
    }
  },
  methods: {
    formatTitle: function(d) {
      var options = {
        weekday: 'long'
      }
      return ut.Capitalize(new Date().toLocaleString(this.locale, options))
    },
    getTrackState: function(state) {
      switch (state) {
        case 0:
          return 'Error'
        case 1:
          return 'Exception'
        case 2:
          return 'Success'
        default:
          return 'Invalid'
      }
    },
    reset: function() {
      this.sekKeyDialog = false

      switch (this.debugType) {
        case 0:
          this.dState = !this.debugState
          break
        case 1:
          this.dStateApi = !this.debugStateApi
          break
      }
      this.debugType = -1
    },
    getString: function(key) {
      let page = this.$store.state.currentTranslator.getString(key)
      return page
    },
    getTracks: function() {
      let self = this
      this.loading = true
      ajax.axios
        .get(
          ajax.baseUrl() +
            '/admin/diag/get/track/from/' +
            self.dateStart +
            '/limit/' +
            self.requestBugItems,
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true
          }
        )
        .then(function(response) {
          ajax.validateToken(response.headers,self.$store)
          self.loading = false
          self.bugsItems = response.data.data
        })
        .catch(function(error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router)
          self.loading = false
          self.$emit(
            'siteAlert',
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.data.errorMessage
          )
        })
    },
    getDebugState: function() {
      let self = this
      ajax.axios
        .get(ajax.baseUrl() + '/admin/diag/get/debugmode', {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true
        })
        .then(function(response) {
          ajax.validateToken(response.headers,self.$store)
          self.debugState = response.data.data.debug
          self.debugStateApi = response.data.data.debugApi
          self.switchInit = false
          self.switchInitApi = false
        })
        .catch(function(error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router)
          self.$emit(
            'siteAlert',
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.data.errorMessage
          )
        })
    },
    removeZombie: function() {
      let self = this
      this.deleteLoading = true
      ajax.axios
        .get(ajax.baseUrl() + '/admin/diag/files/remove/zombie', {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true
        })
        .then(function(response) {
          ajax.validateToken(response.headers,self.$store)
          self.deleteLoading = false
          self.$emit('siteAlertSuccess', response.data.data)
        })
        .catch(function(error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router)
          self.loading = false
          self.$emit(
            'siteAlert',
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.data.errorMessage
          )
        })
    },
    setDebugState: function() {
      let self = this
      if (this.enabled) {
        ajax.axios
          .put(
            ajax.baseUrl() +
              '/admin/diag/set/debugmode/' +
              this.debugType,
            {},
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true
            }
          )
          .then(function(response) {
            ajax.validateToken(response.headers,self.$store)
            self.skey = ''
            self.$emit('siteAlertSuccess', response.data.data)
            self.sekKeyDialog = false
            self.debugType = -1
          })
          .catch(function(error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router)
            self.reset()
            self.skey = ''
            self.$emit(
              'siteAlert',
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.data.errorMessage
            )
          })
      } else {
        ajax.axios
          .delete(
            ajax.baseUrl() +
              '/admin/diag/set/debugmode/' +
              this.debugType,
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true
            }
          )
          .then(function(response) {
            ajax.validateToken(response.headers,self.$store)
            self.skey = ''
            self.$emit('siteAlertSuccess', response.data.data)
            self.sekKeyDialog = false
            self.debugType = -1
          })
          .catch(function(error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router)
            self.skey = ''
            self.reset()
            self.$emit(
              'siteAlert',
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.data.errorMessage
            )
          })
      }
    }
  }
}
</script>

<style>
#com-table .v-table__overflow {
  height: 60vh;
  overflow: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/Diagnostics.vue